import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Events from './Events'
import Main from './Main'
import Users from './Users'
import Companies from './Companies'
import Buildings from './Buildings'
import Clusters from './Clusters'
import Locations from './Locations'
import Reports from './Reports'
import AccessDenied from './AccessDenied'

import { Route, Redirect, Switch, withRouter } from 'react-router-dom'

import './Auth.css'

class Auth extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {}

  render() {
    const isAuthenticated = this.props.token

    if (isAuthenticated) {
      let role = this.props.role

      //e(events)u(users)r(reports)b(buildings)
      let hasAccessToEvents = role.length > 0 && role.charAt(0) != '0'
      let hasAccessToUsers = role.length > 1 && role.charAt(1) != '0'
      let hasAccessToReports = role.length > 2 && role.charAt(2) != '0'
      let hasAccessToBuildings = role.length > 3 && role.charAt(3) != '0'
      let hasAccessToCompanies = role.length > 4 && role.charAt(4) != '0'
      let hasAccessToLocations = role.length > 5 && role.charAt(5) != '0'
      let hasAccessToClusters = role.length > 6 && role.charAt(6) != '0'

      let sections = [{ path: '/', component: '' }, { path: '/admin', component: Main }, { path: '/accessDenied', component: AccessDenied }]

      if (hasAccessToEvents) {
        sections.push({ path: '/events', component: Events })
      }

      if (hasAccessToUsers) {
        sections.push({ path: '/users', component: Users })
      }

      if (hasAccessToReports) {
        sections.push({ path: '/reports', component: Reports })
      }

      if (hasAccessToBuildings) {
        sections.push({ path: '/buildings', component: Buildings })
      }
      if (hasAccessToClusters) {
        sections.push({ path: '/clusters', component: Clusters })
      }

      if (hasAccessToCompanies) {
        sections.push({ path: '/companies', component: Companies })
      }

      if (hasAccessToLocations) {
        sections.push({ path: '/locations', component: Locations })
      }

      return (
        <div className='content'>
          {sections.map((section, index) => (
            <Route exact path={section.path} component={section.component} />
          ))}
        </div>
      )
    } else {
      return <Redirect to='/login' />
    }
  }
}

const mapStateToProps = (state) => {
  return { token: state.usersReducer.token, role: state.usersReducer.role }
}

export default withRouter(connect(mapStateToProps)(Auth))



// WEBPACK FOOTER //
// ./src/containers/Auth.js